import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { Provider } from "react-redux";
import { configureAppStore } from "./store/configureStore.tsx";
import "./assets/css/App.css";
import { BrowserRouter } from "react-router-dom";
import Injector from "./components/hooks/Injector";
import { Toaster } from "sonner";
import "./locales/i18n.ts";

const store = configureAppStore();

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <Provider store={store}>
      <StrictMode>
      <Toaster
        richColors
        position="bottom-right"
        closeButton
        expand
        duration={2000}
      />
        <Injector>
          <App />
        </Injector>
      </StrictMode>
    </Provider>
  </BrowserRouter>
);
